import { render, staticRenderFns } from "./TalkIcon.vue?vue&type=template&id=3ae9bc0a&"
import script from "./TalkIcon.vue?vue&type=script&lang=js&"
export * from "./TalkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports